import { mobileApiRequest } from '../../apiRequests'
//import userflow from 'userflow.js'

const checkIfRedirect = (createDate) => {
    const fiveMinutesInMilliseconds = 5 * 60 * 1000
    const now = Date.now()

    const sfOffsetMilliseconds = -8 * 60 * 60 * 1000
    const createDateUTC = createDate - sfOffsetMilliseconds

    if (now - createDateUTC < fiveMinutesInMilliseconds) {
        if (!localStorage.getItem('redirectTour')) localStorage.setItem('redirectTour', 'true')
        if (!localStorage.getItem('personalWorkspaceOnboarding'))
            localStorage.setItem('personalWorkspaceOnboarding', 'true')
    }
}

export const getUserInfo = async (userID, dispatch) => {
    const action = {
        action: 'getObjects',
        attributeName: 'userID',
        attributeValue: userID,
        class: 'scoop.user.User',
    }
    const result = await mobileApiRequest(action)
    if (result && Array.isArray(result.objects)) {
        checkIfRedirect(result.objects[0].createDate, dispatch)
        if (localStorage.getItem('userFirstName') === 'undefined')
            localStorage.setItem('userFirstName', result.objects[0].firstName)
        return result.objects[0]
    }
}
